// Export de n'importe quel tableau affiché : un bouton « Exporter (Excel) » est ajouté en tête de chaque tableau
// de données (au moins 2 lignes). Le fichier (CSV séparé par « ; », lisible par Excel en français) reprend le titre
// de la section, la date d'export, les en-têtes et les lignes affichées (sans la colonne Actions).
const SELECTOR = 'table.sa-table, table.desk-table, table.data-table, table.lg-table, table.accounting-table';

function sectionTitle(table) {
  let el = table;
  for (let i = 0; i < 6 && el; i += 1) {
    el = el.parentElement;
    const h = el?.querySelector?.('h1, h2, h3');
    if (h && h.textContent.trim()) return h.textContent.trim();
  }
  return 'Export';
}

const clean = (t) => String(t || '').replace(/\s+/g, ' ').trim();
const esc = (v) => `"${String(v).replace(/"/g, '""')}"`;

function exportTable(table) {
  const headRow = table.tHead?.rows?.[0] || table.rows[0];
  const headers = Array.from(headRow?.cells || []).map((c) => clean(c.textContent));
  const skip = new Set(headers.map((h, i) => (/^actions?$/i.test(h) || h === '' ? i : -1)).filter((i) => i >= 0));
  const body = Array.from(table.tBodies?.[0]?.rows || []).filter((r) => r.cells.length > 1);
  const lines = body.map((r) => Array.from(r.cells).filter((_, i) => !skip.has(i)).map((c) => clean(c.innerText || c.textContent)));
  const title = sectionTitle(table);
  const csv = [[title], [`Exporté le ${new Date().toLocaleString('fr-FR')}`], [], headers.filter((_, i) => !skip.has(i)), ...lines]
    .map((r) => r.map(esc).join(';')).join('\r\n');
  const blob = new Blob([`﻿${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title.replace(/[^\p{L}\p{N}]+/gu, '_').slice(0, 60) || 'Export'}_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function enhance(table) {
  if (table.dataset.exportReady || table.closest('[data-no-export]') || table.closest('.modal-content, .modal')) return;
  const rows = table.tBodies?.[0]?.rows?.length || 0;
  if (rows < 2) return;
  table.dataset.exportReady = '1';
  const cap = document.createElement('caption');
  cap.setAttribute('data-hb-export', '1');
  cap.style.cssText = 'caption-side:top;text-align:right;padding:0 0 6px;';
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.textContent = '⬇ Exporter (Excel)';
  btn.title = 'Télécharger ce tableau (fichier lisible dans Excel)';
  btn.style.cssText = 'font:600 12px inherit;padding:4px 10px;border-radius:8px;border:1px solid #cbd5e1;background:#fff;color:#1e3a8a;cursor:pointer';
  btn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); exportTable(table); });
  cap.appendChild(btn);
  table.insertBefore(cap, table.firstChild);
}

let installed = false;
export function installTableExport() {
  if (installed || typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  installed = true;
  let pending = false;
  const scan = () => { pending = false; document.querySelectorAll(SELECTOR).forEach(enhance); };
  const schedule = () => { if (!pending) { pending = true; setTimeout(scan, 400); } };
  const start = () => {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
}
